import {entries, keys} from 'remeda'
import {NotNull} from 'shared/type'
import * as jwt from 'jsonwebtoken'
import {z} from 'zod'
import {type Role} from 'shared/forecast/roleTypes'

const zJwt = z.object({
  workspace_roles: z.record(z.array(z.string()).nullish()).nullish()
})
type Jwt = z.infer<typeof zJwt>
export const workspaceRolesEqual = (a: NotNull<Jwt['workspace_roles']>, b: NotNull<Jwt['workspace_roles']>) => {
  const rolesString = (roles?: string[] | null) => roles?.toSorted().join('|') ?? ''
  return keys(a).length == keys(b).length && entries(a).every(([k, v]) => rolesString(v) == rolesString(b[k]))
}

export const authDataFromToken = (token: string) => {
  const data = zJwt.parse(jwt.decode(token))
  return {
    ...data,
    hasWorkspaceRole: (workspace_id: string, role: Role) =>
      data.workspace_roles?.[workspace_id]?.includes(role) ?? false
  }
}
